<section class="bg-dark text-light py-12">
  <div class="container mx-auto px-4">
    <div *ngIf="topGametype$ | async as gametype" class="max-w-4xl mx-auto text-center">
      <div class="inline-flex items-center bg-dark-light px-4 py-2 rounded-full text-sm mb-6 border border-light/10">
        <span class="text-accent mr-2">✨</span>
        Instant winnen wacht op je
      </div>
      <h1 class="text-4xl md:text-6xl font-extrabold mb-6">{{ gametype.headText }}</h1>
      <p class="text-lg md:text-xl mb-10 text-gray-400 max-w-2xl mx-auto">{{ gametype.headParagraph }}</p>
      

      <div class="hidden md:grid mt-16 grid-cols-3 gap-8 text-center">
        <div>
          <h3 class="font-semibold text-accent mb-2">Veilig & Betrouwbaar</h3>
          <p class="text-sm text-gray-400">Geverifieerd door Nederlandse instanties</p>
        </div>
        <div>
          <h3 class="font-semibold text-accent mb-2">Directe Uitbetalingen</h3>
          <p class="text-sm text-gray-400">Ontvang winsten direct op je rekening</p>
        </div>
        <div>
          <h3 class="font-semibold text-accent mb-2">24/7 Ondersteuning</h3>
          <p class="text-sm text-gray-400">Hulp wanneer je het nodig hebt</p>
        </div>
      </div>
    </div>
  </div>
</section>

